// Mock data for DigiCar platform

export const testimonials = [
  {
    id: 1,
    name: "Kim",
    rating: 5,
    text: "Enkelt, hurtig og lav risiko.",
    timeAgo: "For 12 timer siden"
  },
  {
    id: 2,
    name: "Christian Skjelstad",
    rating: 5,
    text: "Alt iht det de skriver at de tilbyr",
    timeAgo: "For 13 timer siden"
  },
  {
    id: 3,
    name: "Knut Røed",
    rating: 5,
    text: "DigiCar har god og informativ nettside. Tilstandsrapporten på min bil virket å være grundig.",
    timeAgo: "For 15 timer siden"
  },
  {
    id: 4,
    name: "Renate",
    rating: 5,
    text: "Jeg leverte bilen min til NAF senter tirsdag, onsdag var det budrunde på bilen og torsdag var pengene på konto.",
    timeAgo: "For 1 dag siden"
  },
  {
    id: 5,
    name: "Ronny Haugen",
    rating: 5,
    text: "Enkelt og ryddig prosess pengene på konto 6 timer etter signert salgsmelding.",
    timeAgo: "For 1 dag siden"
  },
  {
    id: 6,
    name: "Frank R.",
    rating: 5,
    text: "Opplevde det som en veldig enkel prosess å selge bilen, god kommunikasjon med kundeservice.",
    timeAgo: "For 2 dager siden"
  },
  {
    id: 7,
    name: "Kristoffer",
    rating: 5,
    text: "Dette fungerte over all forventning. Veldig enkelt og greit opplegg.",
    timeAgo: "For 2 dager siden"
  },
  {
    id: 8,
    name: "Moe Myat",
    rating: 5,
    text: "Vi er veldig fornøyde med å bruke DigiCar til å selge bilen. Anbefales.",
    timeAgo: "For 3 dager siden"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Hva kan jeg forvente å få for bilen min hos DigiCar?",
    answer: "Prisen avhenger av bilens tilstand, merke, modell, alder og kilometerstand. Vi gir deg et estimat basert på markedsverdien, og deretter konkurrerer over 2000 bilforhandlere om å gi deg best mulig pris gjennom vår budprosess."
  },
  {
    id: 2,
    question: "Er DigiCar gratis?",
    answer: "Ja, DigiCar er helt gratis for deg som selger. Vi tar ingen kostnader for verdivurdering, testing av bilen eller formidling av salget. Våre inntekter kommer fra bilforhandlerne som kjøper bilen."
  },
  {
    id: 3,
    question: "Kan jeg bruke testrapporten hvis jeg velger å ikke selge?",
    answer: "Ja, testrapporten er din å beholde uavhengig av om du velger å selge bilen eller ikke. Den kan være nyttig hvis du senere velger å selge bilen privat eller gjennom andre kanaler."
  },
  {
    id: 4,
    question: "Får jeg en bedre pris ved innbytte?",
    answer: "Ikke nødvendigvis. Gjennom DigiCar konkurrerer mange forhandlere om bilen din, noe som ofte resulterer i en høyere pris enn ved direkte innbytte hos én forhandler. Vår erfaring viser at konkurransesituasjonen gir deg som selger en bedre pris."
  },
  {
    id: 5,
    question: "Kan dere levere bilen min på teststasjonen gratis?",
    answer: "Vi tilbyr gratis henting og levering av bilen til teststasjonen i de fleste områder. Kontakt kundeservice for å sjekke om dette gjelder for din lokasjon."
  },
  {
    id: 6,
    question: "Hva skjer med kontrakt og ansvar etter salg?",
    answer: "DigiCar håndterer all kontraktsinngåelse og papirarbeid. Etter at salget er gjennomført, overtar kjøper alt reklamasjonsansvar, så du slipper å bekymre deg for eventuelle problemer etter salget."
  }
];

export const benefits = [
  {
    id: 1,
    icon: "coins",
    title: "Kostnadsfritt",
    description: "Ingen kostnader for deg som selger."
  },
  {
    id: 2,
    icon: "shield-check",
    title: "Slipp reklamasjonsansvar",
    description: "Vi tar ansvaret når bilen er solgt."
  },
  {
    id: 3,
    icon: "smile",
    title: "Uforpliktende tilbud",
    description: "Du velger selv om du godtar høyeste bud."
  },
  {
    id: 4,
    icon: "clock",
    title: "Selg bilen raskt",
    description: "Etter budrunden, er bilen din solgt på 1 dag dersom du aksepterer høyeste bud."
  },
  {
    id: 5,
    icon: "star",
    title: "Over 90 000 har solgt med DigiCar",
    description: "DigiCar har hjulpet med bilsalg siden 2015."
  },
  {
    id: 6,
    icon: "map-pin",
    title: "Lever bilen i hele landet",
    description: "Vi dekker hele Norge."
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Skriv inn reg.nr. og km",
    description: "Få et estimat med en gang. Vi henter resten av opplysningene selv.",
    image: "https://images.unsplash.com/photo-1567969736936-d1fb4f5d61e7"
  },
  {
    id: 2,
    title: "Vi sjekker bilen",
    description: "Book time eller vi henter. Vi tar bilder og sjekker stand. Budrunden starter.",
    image: "https://images.unsplash.com/photo-1487754180451-c456f719a1fc"
  },
  {
    id: 3,
    title: "Du velger beste bud",
    description: "Se alle bud og velg det beste. Pengene på konto innen få dager.",
    image: "https://images.unsplash.com/photo-1652660771416-032b5debd5be"
  }
];

export const auctionBids = [
  { dealer: "Forhandler 1", amount: 264000 },
  { dealer: "Forhandler 2", amount: 265000 },
  { dealer: "Forhandler 3", amount: 266000 },
  { dealer: "Forhandler 4", amount: 267000 },
  { dealer: "Forhandler 5", amount: 268000 }
];

export const stats = {
  totalSales: 92148,
  rating: 4.7,
  reviews: 2000
};